/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crisp_Free_Cod_PullInputs */

const en_crisp_free_cod_pull = /** @type {(inputs: Crisp_Free_Cod_PullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending`)
};

const de_crisp_free_cod_pull = /** @type {(inputs: Crisp_Free_Cod_PullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird gesendet`)
};

/**
* | output |
* | --- |
* | "Sending" |
*
* @param {Crisp_Free_Cod_PullInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const crisp_free_cod_pull = /** @type {((inputs?: Crisp_Free_Cod_PullInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crisp_Free_Cod_PullInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crisp_free_cod_pull(inputs)
	return de_crisp_free_cod_pull(inputs)
});